import * as Sentry from '@sentry/nextjs';

import { SENTRY_DSN } from '../constants';
import { isSentryEnabled } from '../services/sentry';

export const initializeSentryClient = (env_name: string): void => {
	const isProd = env_name === 'production' || env_name === 'prod';

	Sentry.init({
		dsn: SENTRY_DSN,
		environment: env_name,

		// Add optional integrations for additional features
		integrations: [Sentry.replayIntegration()],

		// Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
		tracesSampleRate: isProd ? 0.1 : 1,

		profilesSampleRate: isProd ? 0.1 : 1,

		// Define how likely Replay events are sampled.
		// This sets the sample rate to be 10%. You may want this to be 100% while
		// in development and sample at a lower rate in production
		replaysSessionSampleRate: isProd ? 0.1 : 1,

		// Define how likely Replay events are sampled when an error occurs.
		replaysOnErrorSampleRate: isProd ? 0.1 : 1,

		beforeSend(event) {
			if (!isSentryEnabled()) {
				// return null to discard the event
				return null;
			}
			// send event when enabled
			return event;
		},
	});
};
